import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  role: string;
  kits?: string[];
  portals?: string[];
};

const [useUpdateSpaceJoinWith, updateSpaceJoinWith] = createAsyncAction(
  "spaces/updateSpaceJoinWith",
  async ({ spaceId, role, kits, portals }: Args) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}`,
      method: "PUT",
      data: {
        join_settings: {
          join_with: {
            role: role,
            portals: [...new Set(portals)].map(uuid => {
              return { uuid: uuid };
            }),
            kits: [...new Set(kits)].map(uuid => {
              return { uuid: uuid, role: "guest" };
            }),
          },
        },
      },
    });
    return { ...res, result: res.result.space };
  }
);

export default useUpdateSpaceJoinWith;
export { updateSpaceJoinWith };
